/* eslint-disable no-param-reassign */
import AGREGAR_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/agregarUsuario.gql';
import ACTUALIZAR_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarUsuario.gql';
import ACTUALIZAR_USUARIO_BASICO from '@/graphql/mutations/administracion/catalogos/usuarios/actualizarUsuarioBasico.gql';
import REMOVER_USUARIO from '@/graphql/mutations/administracion/catalogos/usuarios/removerUsuario.gql';
import USUARIOS from '@/graphql/querys/administracion/catalogos/usuarios/usuarios.gql';
import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import listadoRoles from '@/helpers/roles';
import listadoPerfiles from '@/helpers/perfiles';

export default {
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
    usuarios: {
      query: USUARIOS,
    },
  },

  mounted() {
    this.limpiarRoles();
    this.rolesScopes = [
      ...listadoRoles.sort((a, b) => {
        if (a.rol === 'Administración') return -1;
        return a.rol.localeCompare(b.rol);
      }),
    ];
  },
  methods: {
    // Deseleccionar todos los checkbox Scopes
    limpiarRoles() {
      this.getRolesList.forEach((r) => {
        r.scopes.ver = false;
        r.scopes.crear = false;
        r.scopes.editar = false;
        r.scopes.eliminar = false;
      });
    },

    // Al selecionar un scope, evalua a true el rol:ver correspondiente
    seleccionaScope(scopes) {
      // Marcar el Rol:ver si se selecciona un scope
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.getRolesList[scopes.split('-')[2]].scopes)) {
        if (value === true && key) {
          this.getRolesList[scopes.split('-')[2]].scopes.ver = true;
          break;
        } else {
          this.getRolesList[scopes.split('-')[2]].scopes.ver = false;
        }
      }
    },
    // Al deseleccionar rol:ver, evalua a false a todos sus scopes correspondientes
    seleccionaRol(rolScopes, index) {
      // Marcar o desmarcar Scope:true-false si se selecciona o no un rol
      // eslint-disable-next-line no-restricted-syntax
      for (const [key] of Object.entries(rolScopes)) {
        if (key !== 'ver') {
          this.getRolesList[index].scopes[key] = false;
        }
      }
    },
    // Al seleccionar un Perfil se seleccional rol/scopes configurados
    seleccionaPerfil(perfil) {
      // Marcar scopes de acuerdo a la configuración del perfil seleccionado
      this.limpiarRoles();
      this.getPerfilesList.find((p) => p.perfil === perfil).roles.forEach((r) => {
        this.getRolesList.filter((roles) => r.rol === roles.rol).forEach((rol) => {
          // eslint-disable-next-line no-restricted-syntax
          for (const key of Object.keys(rol.scopes)) {
            rol.scopes[key] = r.scopes[key];
          }
        });
      });
    },
    // Marcar los rol/scopes al montar el componente según del usuario
    marcaRolesEditar() {
      this.scopes.forEach((s) => {
        const scope = s.split(':');
        this.getRolesList.filter((roles) => scope[0] === roles.rol).forEach((rol) => {
          rol.scopes[scope[1]] = true;
        });
      });
    },

    async mixAgregarUsuario() {
      const { usuario } = this;
      const { roles, scopes } = this.getRolesAsigados;
      usuario.roles = roles;
      usuario.scopes = scopes;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_USUARIO,
          variables: { usuario },
          update: (cache, { data: { agregarUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            data.usuarios.push(agregarUsuario);
            cache.writeQuery({ query: USUARIOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.cerrar();
    },

    async mixActualizarUsuario() {
      const { usuario } = this;
      const { id } = this.usuarioEditar;
      const { roles, scopes } = this.getRolesAsigados;
      usuario.roles = roles;
      usuario.scopes = scopes;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_USUARIO,
          variables: { id, usuario },
          update: (cache, { data: { actualizarUsuario } }) => {
            const data = cache.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios.findIndex((u) => u.id === actualizarUsuario.id);
            if (index !== -1) {
              usuarios.splice(index, 1, actualizarUsuario);
            }

            cache.writeQuery({ query: USUARIOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.cerrar();
    },

    async mixActualizarUsuarioBasico() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_USUARIO_BASICO,
          variables: {
            id: this.usuarioId,
            usuario: this.usuario,
          },
          update: (store, { data: { actualizarUsuarioBasico } }) => {
            const data = store.readQuery({ query: USUARIOS });
            const { usuarios } = data;
            const index = usuarios
              .findIndex((usuario) => usuario.id === actualizarUsuarioBasico.id);
            if (index !== -1) {
              usuarios.splice(index, 1, actualizarUsuarioBasico);
            }
            store.writeQuery({ query: USUARIOS, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarUsuario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_USUARIO,
        variables: {
          id: this.usuarioEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: USUARIOS });
          const { usuarios } = data;
          const index = usuarios
            .findIndex((usuario) => usuario.id === this.usuarioEliminar.id);
          if (index !== -1) {
            usuarios.splice(index, 1);
          }
          store.writeQuery({ query: USUARIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

  },
  computed: {
    getFuncionarios() {
      if (!this.funcionarios) return [];
      return this.funcionarios;
    },
    getRolesList() {
      return listadoRoles.sort((a, b) => {
        if (a.rol === 'Administración') return -1;
        return a.rol.localeCompare(b.rol);
      });
    },
    getNamePerfilesList() {
      const perfiles = listadoPerfiles.sort((a, b) => a.perfil.localeCompare(b.perfil));
      return perfiles.map((p) => p.perfil);
    },
    getPerfilesList() {
      const perfiles = listadoPerfiles.sort((a, b) => a.perfil.localeCompare(b.perfil));
      return perfiles;
    },
    getRolesAsigados() {
      const rolesList = [];
      const scopeList = [];

      this.rolesScopes
        .filter((item) => Object.values(item.scopes).some((elem) => elem === true))
        .forEach((item) => {
          const scopes = Object.entries(item.scopes)
            .map(([key, val]) => (val ? key : false))
            .filter((key) => key);
          rolesList.push(item.rol);
          scopes.forEach((scope) => {
            scopeList.push(`${item.rol}:${scope}`);
          });
        });
      // agrega por default el rol-administracion:ver cuando esta seleccionado uno o mas
      if (rolesList.length > 0) {
        rolesList.push('Administración');
        scopeList.push('Administración:ver');
      }
      return {
        roles: rolesList,
        scopes: scopeList,
      };
    },
  },
};
